import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c6dfcf5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "response-handle-page" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 1 }

import CmTable from '@/components/cmTable/index.vue'
import SearchFilterBar from '@/components/searchFilterBar/index.vue'
import { computed, reactive, ref, onMounted, onUnmounted, nextTick, watch } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import {
  ResponseHandlingService,
  RiskTerminalList,
  TerminalRiskRequestParams,
  TerminalRiskStatisticsResponseData,
} from './service'
import {
  FormSize,
  FormType,
  ObjectFormItem,
} from '@/components/cmForm/types'
import GroupTreeSelector from '../../_components/group-tree-selector/group-tree-selector.vue'
import { formatMapToOptions } from '@/utils/tool'
import { TerminalType, TerminalTypeLabel } from '../../_enum/terminal-type'
import { TableActOpt, TableOpt } from '@/components/cmTable/types'
import StatisticsCards from '../../_components/statistics-cards/statistics-cards.vue'
import type { StatisticsCardItem } from '../../_components/statistics-cards/statistics-cards.vue'
import { isolation_status, risk_type, status_label_color, login_status } from './types'
import { computerInfoCols } from '../../data-safe/ransomware-protection/types/ransomware-incident'
import { listCol } from '@/utils/list-columns-i18n'
import DataDetail from './components/DataDetail.vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import { PermissionFe } from '@/services/service-permission.service'
import Card from '../../_components/card/card.vue'
import { useRoute } from 'vue-router'

type FilterBarKeys = 'group_id' | 'risk_type' | 'isolation_status' | 'login_status' | 'system_type'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t, locale } = useI18n()

function isolationStatusCellText(value: isolation_status): string {
  void locale.value
  const map: Record<isolation_status, string> = {
    [isolation_status.unknown_info]: t('responseHandle.isolationCellNotIsolated'),
    [isolation_status.separated]: t('responseHandle.isolationCellSeparated'),
    [isolation_status.disSeparated]: t('responseHandle.isolationCellNotIsolated'),
    [isolation_status.dispatching]: t('responseHandle.isolationCellDispatching'),
    [isolation_status.fail]: t('responseHandle.isolationCellFail'),
    [isolation_status.recovering]: t('responseHandle.isolationCellRecovering'),
    [isolation_status.recoverFail]: t('responseHandle.isolationCellRecoverFail'),
  }
  return map[value as isolation_status] ?? '--'
}

const injector = useReflectiveInjector([ResponseHandlingService])
const responseHandleService = injector.get(ResponseHandlingService)
// 获取风险终端列表
const api = responseHandleService.getTerminalRiskList.bind(responseHandleService)
// 终端风险详情
const getTerminalRiskDetailApi = responseHandleService.getTerminalRiskDetail.bind(responseHandleService)
// 获取弱口令账户信息
const getTerminalOrderGetWeakPasswordInfoApi = responseHandleService.getTerminalOrderGetWeakPasswordInfo.bind(responseHandleService)
// 隔离终端
const getTerminalOrderIsolationApi = responseHandleService.getTerminalOrderIsolation.bind(responseHandleService)
// 风险终端统计
const getTerminalRiskStatisticsApi = responseHandleService.getTerminalRiskStatistics.bind(responseHandleService)
const getTerminalAccountLoginSessionHistory = responseHandleService.getTerminalAccountLoginSessionHistory.bind(responseHandleService)
// 获取隔离状态
const getTerminalGetIsolationStatusApi = responseHandleService.getTerminalGetIsolationStatus.bind(responseHandleService)
const activeHref = ref(1)
const row = ref<Partial<RiskTerminalList>>({})
const tableRef = ref()

const { refreshList } = useCmTableListRefresh(tableRef)
// 顶部统计：与 DataShow 的 key 顺序一致，索引即 risk_type，用于列表筛选
const statisticsData = ref<Partial<TerminalRiskStatisticsResponseData>>({})
const statisticsItems = computed<StatisticsCardItem[]>(() => {
  const d = statisticsData.value
  const rows: StatisticsCardItem[] = [
    { label: t('responseHandle.allRiskTerminals'), value: d.risk_terminal_count ?? 0 },
    { label: t('responseHandle.virusRiskTerminals'), value: d.virus_affect_count ?? 0 },
    { label: t('responseHandle.leakRiskTerminals'), value: d.leak_affect_count ?? 0 },
    { label: t('responseHandle.portRiskTerminals'), value: d.port_affect_count ?? 0 },
    { label: t('responseHandle.baselineRiskTerminals'), value: d.baseline_substandard_count ?? 0 },
    { label: t('responseHandle.ransomwareRiskTerminals'), value: d.ransomware_affect_count ?? 0 },
    { label: t('responseHandle.weakPasswordTerminals'), value: d.weak_password_affect_count ?? 0 },
    { label: t('responseHandle.isolatedTerminals'), value: d.isolation_count ?? 0 },
  ]
  return rows.map((item, index) => ({
    ...item,
    disabled: index !== 0 && Number(item.value) === 0,
  }))
})
async function loadStatistics() {
  try {
    const res = await getTerminalRiskStatisticsApi()
    statisticsData.value = res ?? {}
  } catch {
    statisticsData.value = {}
  }
}
function handleStatisticsClick(index: number, _item: StatisticsCardItem) {
  handleItem(index as risk_type)
}
const route = useRoute()

const RISK_TYPE_QUERY_VALUES = new Set<number>(
  (Object.values(risk_type).filter((v): v is number => typeof v === 'number')),
)

function parseRiskTypeFromRouteQuery (): risk_type {
  const q = route.query.risk_type
  if (q === undefined || q === null || q === '') {
    return risk_type.All
  }
  const raw = Array.isArray(q) ? q[0] : q
  const n = Number(raw)
  if (Number.isNaN(n) || !RISK_TYPE_QUERY_VALUES.has(n)) {
    return risk_type.All
  }
  return n as risk_type
}

const queryForm = reactive<Partial<TerminalRiskRequestParams>>({
  permission_names: [PermissionFe.port_control, PermissionFe.linux_base_auth, PermissionFe.ransomware_protect],
  risk_type: parseRiskTypeFromRouteQuery(),
  key_word: '',
  group_id: -1,
  isolation_status: route?.query?.isolation_status
    ? (Number(route?.query?.isolation_status) as login_status)
    : undefined,
})

watch(
  () => route.query.risk_type,
  () => {
    const next = parseRiskTypeFromRouteQuery()
    if (queryForm.risk_type === next) return
    queryForm.risk_type = next
    void nextTick(() => {
      void refreshList()
    })
  },
)

const filterFormColumns = computed<ObjectFormItem<typeof queryForm, FilterBarKeys>>(() => {
  void locale.value
  return {
    group_id: {
      colOpt: { style:'flex:0 0 150px' },
      slot: true,
      hiddenAllLabel: true,
      type: FormType.Select,
      outSearchFiledFlag: true,
      get label() {
        return listCol(t, 'groupName')
      },
      get placeholder() {
        return t('responseHandle.groupPlaceholder')
      },
    },
    risk_type: {
      colOpt: { span: 12 },
      hiddenAllLabel: false,
      type: FormType.Select,
      get label() {
        return t('responseHandle.riskTypePlaceholder')
      },
      get dictData() {
        return formatMapToOptions(
          {
            [risk_type.All]: t('responseHandle.allRiskTerminals'),
            [risk_type.virus]: t('responseHandle.virusRiskTerminals'),
            [risk_type.vulnerability]: t('responseHandle.leakRiskTerminals'),
            [risk_type.port]: t('responseHandle.portRiskTerminals'),
            [risk_type.baseline]: t('responseHandle.baselineRiskTerminals'),
            [risk_type.blackmail]: t('responseHandle.ransomwareRiskTerminals'),
            [risk_type.weak_mouth]: t('responseHandle.weakPasswordTerminals'),
            [risk_type.separated]: t('responseHandle.isolatedTerminals'),
          },
          true,
        ).filter((item) => item.value !== risk_type.separated)
      },
      get placeholder() {
        return t('responseHandle.riskTypePlaceholder')
      },
      selectOpt: {
        clearable: true,
      },
    },
    isolation_status: {
      colOpt: { span: 12 },
      hiddenAllLabel: false,
      type: FormType.Select,
      get label() {
        return t('responseHandle.isolationStatus')
      },
      get dictData() {
        return formatMapToOptions(
          {
            [login_status.online]: t('responseHandle.isolationFilterIsolated'),
            [login_status.offline]: t('responseHandle.isolationFilterNotIsolated'),
          },
          true,
        )
      },
      get placeholder() {
        return t('responseHandle.isolationStatusPlaceholder')
      },
      selectOpt: {
        clearable: true,
      },
    },
    login_status: {
      colOpt: { span: 12 },
      hiddenAllLabel: false,
      type: FormType.Select,
      get label() {
        return t('responseHandle.onlineStatusPlaceholder')
      },
      get dictData() {
        return formatMapToOptions(
          {
            [login_status.online]: t('responseHandle.terminalLoginOnline'),
            [login_status.offline]: t('responseHandle.terminalLoginOffline'),
          },
          true,
        )
      },
      get placeholder() {
        return t('responseHandle.onlineStatusPlaceholder')
      },
      selectOpt: {
        clearable: true,
      },
    },
    system_type: {
      colOpt: { span: 12 },
      hiddenAllLabel: false,
      type: FormType.Select,
      get label() {
        return t('responseHandle.osPlaceholder')
      },
      dictData: formatMapToOptions(TerminalTypeLabel, true).filter((item) => item.value !== TerminalType.mac),
      get placeholder() {
        return t('responseHandle.osPlaceholder')
      },
      selectOpt: {
        clearable: true,
      },
    },
  }
})

async function handleSearch(value: string) {
  await nextTick()
  queryForm.key_word = value
  void refreshList()
}

async function handleQuery() {
  await nextTick()
  void refreshList()
}

function handleFilterBarReset() {
  queryForm.key_word = ''
  queryForm.group_id = -1
  queryForm.risk_type = risk_type.All
  queryForm.isolation_status = undefined
  queryForm.login_status = undefined
  queryForm.system_type = undefined
  queryForm.permission_names = [
    PermissionFe.port_control,
    PermissionFe.linux_base_auth,
    PermissionFe.ransomware_protect,
  ]
}
const visible = ref(false)
const btnOpt = { size: FormSize.Small, text: true, type: 'text' }
const handleCountItem = (sectionIndex: number, r: Partial<RiskTerminalList>) => {
  if (sectionIndex === 6 && r.system_type === TerminalType.linux) return;
  row.value = r
  console.log('row.value :>> ', row.value);
  activeHref.value = sectionIndex
  visible.value = true
}
const tableActOpt = computed<TableActOpt>(() => ({
  operateType: 'menu', dropdownOpt: { size: 'small' },
  operateDropdownTitle: t('responseHandle.moreActions'),
  columnOpt: { label: listCol(t, 'operation'), width: 200, align: 'left', fixed: 'right' },
  actionButtons: (rowItem: RiskTerminalList) => [
    { name: t('responseHandle.handleVirus'), opt: btnOpt, events: { click() { handleCountItem(1, rowItem) } } },
    { name: t('responseHandle.fixLeak'), opt: btnOpt, events: { click() { handleCountItem(4, rowItem) } } },
    { name: t('responseHandle.fixBaseline'), opt: btnOpt, events: { click() { handleCountItem(5, rowItem) } } },
    { name: t('responseHandle.blockPort'), opt: btnOpt, events: { click() { handleCountItem(3, rowItem) } } },
    { name: t('responseHandle.killProcess'), opt: btnOpt, show: () => rowItem.system_type !== TerminalType.linux, events: { click() { handleCountItem(7, rowItem) } } },
  ],
}))

const tableOpt = computed<TableOpt>(() => ({
  bodyStyle: 'background: var(--cm-color-card-bg);padding:0',
  containerOpt: { style: 'padding: 0;background: var(--cm-color-card-bg)' },
  height: '100%',
  path: 'risk_terminal_list',
  showActionBar: false,
  showForm: false,
  showRightToolbar: false,
  rowKey: 'device_id',
  selection: false,
  computerClick(row: RiskTerminalList) {
    handleCountItem(0, row)
  },
  columns: [
    ...computerInfoCols(false, true, t),
    { label: t('responseHandle.virusRisk'),minWidth: 160, prop: 'unhandled_risk_count' },
    { label: t('responseHandle.ransomwareRisk'),minWidth: 160, prop: 'ransomware_count' },
    { label: t('responseHandle.leakRisk'), minWidth: 160,prop: 'leak_count' },
    { label: t('responseHandle.baselineRisk'),minWidth: 160, prop: 'substandard_count' },
    { label: t('responseHandle.portRisk'),minWidth: 160, prop: 'danger_port_count' },
    { label: t('responseHandle.weakPasswordAccount'),minWidth: 160, prop: 'weak_password_account_count' },
    { label: t('responseHandle.isolationStatus'),minWidth: 160, prop: 'isolation_status' },
  ],
}))
const handleItem = (key: risk_type) => {
  if (key === risk_type.separated) {
    ;(queryForm as Record<string, unknown>).isolation_status = isolation_status.separated
  } else {
    queryForm.risk_type = key
  }
  void refreshList()
}
const refresh = () => {
  void refreshList()
  loadStatistics()
}
const updateGroupId = async (groupId: number) => {
  queryForm.group_id = groupId
  await refreshList()
}
const flag = (status) => [isolation_status.separated, isolation_status.recovering, isolation_status.recoverFail].includes(status)
// 隔离状态轮询定时器
const isolationStatusTimer = ref<ReturnType<typeof setInterval> | null>(null)
// 当前正在轮询的设备ID
const pollingDeviceId = ref<string | null>(null)

// 更新表格中指定行的隔离状态
const updateRowIsolationStatus = (deviceId: string, status: number) => {
  try {
    // 通过 el-table 的内部状态访问数据
    const elTable = tableRef.value?.tableRef
    if (elTable) {
      // el-table 的数据存储在 data 属性中，这是响应式的
      const tableData = (elTable as any).data || (elTable as any).store?.states?.data || []
      const targetRow = tableData.find((item: RiskTerminalList) => item.device_id === deviceId)
      if (targetRow) {
        // 直接修改对象属性，Vue 的响应式系统会自动更新视图
        targetRow.isolation_status = status
      }
    }
  } catch (error) {
    console.error('更新隔离状态失败:', error)
  }
}

// 轮询隔离状态
const pollIsolationStatus = async (deviceId: string) => {
  try {
    const result = await getTerminalGetIsolationStatusApi({ device_list: [deviceId] })
    if (result?.isolation_status_list && result.isolation_status_list.length > 0) {
      const status = result.isolation_status_list[0]
      updateRowIsolationStatus(deviceId, status)

      // 只有当状态是 3（正在下发隔离）或 5（正在下发恢复）时才继续轮询，其他状态停止轮询
      if (status === isolation_status.dispatching || status === isolation_status.recovering) {
        // 继续轮询，不做任何操作
      } else {
        // 其他状态停止轮询
        stopPolling()
      }
    }
  } catch (error) {
    console.error('获取隔离状态失败:', error)
    stopPolling()
  }
}

// 停止轮询
const stopPolling = () => {
  if (isolationStatusTimer.value) {
    clearInterval(isolationStatusTimer.value)
    isolationStatusTimer.value = null
    pollingDeviceId.value = null
  }
}

// 开始轮询隔离状态
const startPolling = (deviceId: string) => {
  // 如果已有定时器在运行，先停止
  stopPolling()

  pollingDeviceId.value = deviceId
  // 立即执行一次
  pollIsolationStatus(deviceId)
  // 每5秒执行一次
  isolationStatusTimer.value = setInterval(() => {
    if (pollingDeviceId.value === deviceId) {
      pollIsolationStatus(deviceId)
    }
  }, 5000)
}

const handleNet = (row: RiskTerminalList) => {
  const title = !flag(row.isolation_status) ? t('responseHandle.confirmIsolate') : t('responseHandle.confirmRestore')
  const subtitle = !flag(row.isolation_status) ? t('responseHandle.confirmIsolateDesc') : t('responseHandle.confirmRestoreDesc')
  ElMessageBox.confirm(`<div>
  <strong style='color: var(--cm-color-text-primary);font-size: 16px;font-weight: 700;'>${title}</strong>
  <div style='color: var(--cm-color-text-secondary);margin-top:10px'>${subtitle}</div>
  </div>`, t('responseHandle.tip'), { dangerouslyUseHTMLString: true }).then(async () => {
    await getTerminalOrderIsolationApi({ execute_type: 0, device_list: [row.device_id], isolation_enabled: flag(row.isolation_status) ? isolation_status.disSeparated : isolation_status.separated })
    ElMessage.success(t('responseHandle.opSuccess'))
    visible.value = false
    // 启动轮询，每5秒更新一次隔离状态
    startPolling(row.device_id)
  })
}

// 组件挂载时加载统计
onMounted(() => {
  loadStatistics()
})

// 组件卸载时清理定时器
onUnmounted(() => {
  stopPolling()
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(StatisticsCards, {
      items: statisticsItems.value,
      clickable: "",
      onItemClick: handleStatisticsClick
    }, null, 8, ["items"]),
    _createVNode(Card, {
      size: "second",
      title: _ctx.$t('responseHandle.terminalListTitle'),
      class: "response-handle-list-card",
      cardHeaderStyle: {marginBottom:'0'}
    }, {
      default: _withCtx(() => [
        _createVNode(CmTable, {
          tableOpt: tableOpt.value,
          modelValue: queryForm,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryForm) = $event)),
          tableActOpt: tableActOpt.value,
          api: _unref(api),
          "first-loading": false,
          ref_key: "tableRef",
          ref: tableRef,
          pageOption: {
          style: 'padding-bottom: 16px',
          pageNumName: 'page',
          pageSizeName: 'limit',
        }
        }, {
          header: _withCtx(() => [
            _createVNode(SearchFilterBar, {
              modelValue: queryForm,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryForm) = $event)),
              "form-columns": filterFormColumns.value,
              "show-search": true,
              class: "cm-ui-mt16",
              "sync-search-from-field": "key_word",
              "search-placeholder": _ctx.$t('responseHandle.searchPlaceholder'),
              "force-use-popover": true,
              "popover-width": 440,
              onSearch: handleSearch,
              onQuery: handleQuery,
              onReset: handleFilterBarReset
            }, {
              group_id: _withCtx(() => [
                _createVNode(GroupTreeSelector, {
                  "terminal-type": [_unref(TerminalType).windows, _unref(TerminalType).linux, _unref(TerminalType).windowsServer],
                  onSelected: updateGroupId
                }, null, 8, ["terminal-type"])
              ]),
              _: 1
            }, 8, ["modelValue", "form-columns", "search-placeholder"])
          ]),
          "prefix-action": _withCtx(({ row }) => [
            _createVNode(_component_el_tooltip, {
              class: "box-item",
              effect: "dark",
              content: _ctx.$t('responseHandle.linuxNotSupport'),
              disabled: row.system_type !== _unref(TerminalType).linux,
              placement: "top-start"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "text",
                  size: 'mini',
                  disabled: row.system_type === _unref(TerminalType).linux,
                  style: {"font-weight":"normal"},
                  onClick: ($event: any) => (handleNet(row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(flag(row.isolation_status) ? _ctx.$t('responseHandle.restoreNetwork') : _ctx.$t('responseHandle.isolateNetwork')), 1)
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"])
              ]),
              _: 2
            }, 1032, ["content", "disabled"])
          ]),
          isolation_status: _withCtx(({ value }) => [
            _createElementVNode("div", {
              class: "cm-align-center",
              style: _normalizeStyle({ color: _unref(status_label_color)[value] })
            }, [
              _createTextVNode(_toDisplayString(isolationStatusCellText(value)), 1),
              _createElementVNode("div", {
                class: _normalizeClass({ 'dot-flashing': [_unref(isolation_status).dispatching, _unref(isolation_status).recovering].includes(value) })
              }, null, 2)
            ], 4)
          ]),
          unhandled_risk_count: _withCtx(({ value, row }) => [
            value
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "num-item",
                  onClick: ($event: any) => (handleCountItem(1, row))
                }, _toDisplayString(value), 9, _hoisted_2))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString('--')))
          ]),
          leak_count: _withCtx(({ value, row }) => [
            value
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "num-item",
                  onClick: ($event: any) => (handleCountItem(4, row))
                }, _toDisplayString(value), 9, _hoisted_4))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString('--')))
          ]),
          substandard_count: _withCtx(({ value, row }) => [
            value
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "num-item",
                  onClick: ($event: any) => (handleCountItem(5, row))
                }, _toDisplayString(value), 9, _hoisted_6))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString('--')))
          ]),
          danger_port_count: _withCtx(({ value, row }) => [
            value
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "num-item",
                  onClick: ($event: any) => (handleCountItem(3, row))
                }, _toDisplayString(value), 9, _hoisted_8))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString('--')))
          ]),
          ransomware_count: _withCtx(({ value, row }) => [
            value
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "num-item",
                  onClick: ($event: any) => (handleCountItem(2, row))
                }, _toDisplayString(value), 9, _hoisted_10))
              : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString('--')))
          ]),
          weak_password_account_count: _withCtx(({ value, row }) => [
            value
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "num-item",
                  onClick: ($event: any) => (handleCountItem(6, row))
                }, _toDisplayString(value), 9, _hoisted_12))
              : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString('--')))
          ]),
          _: 1
        }, 8, ["tableOpt", "modelValue", "tableActOpt", "api"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(DataDetail, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
      activeHref: activeHref.value,
      detailInfo: row.value,
      onHandleNet: _cache[3] || (_cache[3] = ($event: any) => (handleNet(row.value))),
      onRefresh: refresh,
      api: { getTerminalRiskDetailApi: _unref(getTerminalRiskDetailApi), getTerminalOrderGetWeakPasswordInfoApi: _unref(getTerminalOrderGetWeakPasswordInfoApi), getTerminalAccountLoginSessionHistory: _unref(getTerminalAccountLoginSessionHistory), getTerminalOrderIsolationApi: _unref(getTerminalOrderIsolationApi) }
    }, null, 8, ["modelValue", "activeHref", "detailInfo", "api"])
  ]))
}
}

})